import React, { useEffect, useState } from "react";
import Images from "../../assets/Image";
import { useForm } from "react-hook-form";
import FileName from "../../broucherPdf/filePdf";
import ContactUsSidebar from "../ContactUsSidebar";
import { Link } from "react-router-dom";
const ChemicalComp = () => {
  // const { register, handleSubmit } = useForm();
  const {
    formState: { errors },
    register,
    handleSubmit,
  } = useForm();

  const [showImage, setShowImage] = useState(false);

  useEffect(() => {
    // Trigger the animation when the component is mounted
    setShowImage(true);
  }, []);
  const imageList = [
    {
      path: Images?.uspstream2,
      imageName: "USP JETSTREAM II",
      fileName: "USP JETSTREAM II.pdf",
      downloadFile: FileName?.usp_JETSTREAM_II,
      fileUrl: "/product/uspJetStream2",
    },
    {
      path: Images?.uspstream4,
      imageName: "USP A-2120",
      fileName: " USP A-2120.pdf",
      downloadFile: FileName?.usp_a2120,
      fileUrl: "/product/uspA2120",
    },
    {
      path: Images?.uspstream3,
      imageName: "USP STREAMLINE 4SP",
      fileName: "STREAMLINE 4SP.pdf",
      downloadFile: FileName?.STREAMLINE_4sp,
      fileUrl: "/product/uspStreamLine4SP",
    },
    {
      path: Images?.uspstream2,
      imageName: "USP JETSTREAM II (Dual Head)",
      fileName: "JETSTREAM II DUAL PRINTHEAD SYSTEM.pdf",
      downloadFile: FileName?.usp_JETSTREAM_II_DUAL_HEAD,
      fileUrl: "/product/uspJetStreamDualHead",
    },
  ];
  const hightResolution = [
    {
      path: Images?.uspstream5,
      imageName: "USP COPILOT 128 & 256",
      fileName: "USP COPILOT 128-256.pdf",
      downloadFile: FileName?.usp_COPILOt_128_256,
      fileUrl: "/product/copilot128-256",
    },
    {
      path: Images?.uspstream7,
      imageName: "USP COPILOT MAX 400",
      fileName: "USP COPILOT 400.pdf",
      downloadFile: FileName?.usp_COPILOt_400,
      fileUrl: "/product/copilotMax400",
    },
    {
      path: Images?.uspstream8,
      imageName: "USP COPILOT MAX 512i",
      fileName: "USP CoPilot MAX 512i TURBO.pdf",
      downloadFile: FileName?.usp_CoPilot_MAX_512i_TURBO,
      fileUrl: "/product/copilotMax512iTurbo",
    },
    {
      path: Images?.uspstream9,
      imageName: "USP COPILOT MAX TURBO",
      fileName: "USP CO PILOT MAX TURBO.pdf",
      downloadFile: FileName?.usp_CO_PILOT_MAX_TURBO,
      fileUrl: "/product/copilotMaxTurbo",
    },
    {
      path: Images?.uspstream10,
      imageName: "USP COPILOT MAX LT",
      fileName: "USP COPILOT MAX LT.pdf",
      downloadFile: FileName?.usp_COPILOT_MAX_LT,
      fileUrl: "/product/copilotMaxlt",
    },
    {
      path: Images?.uspstream11,
      imageName: "USP COPILOT GEMINI",
      fileName: "USP COPILOT GEMINI.pdf",
      downloadFile: FileName?.Co_Pilot_Gemini,
      path: Images?.uspstream5,
      imageName: "USP COPILOT 128",
      fileUrl: "/product/copilotGemini",
    },
  ];
  const laserPrinter = [
    {
      path: Images?.uspstream18,
      imageName: "USP CO2 LASER",
      fileName: "USP CO2 LASER.pdf",
      downloadFile: FileName?.usp_CO2_Laser,
      fileUrl: "/product/uspCo2Laser",
    },
    {
      path: Images?.uspstream12,
      imageName: "USP FIBER LASER",
      fileName: "USP FIBER LASER.pdf",
      downloadFile: FileName?.usp_FIBER_LASER,
      fileUrl: "/product/uspFiberLaser",
    },
  ];

  const onSubmit = (data) => {
    console.log("data", data);
  };
  return (
    <>
      <div className="automobile_industry_head_section">
        <div className="automobile_industry_left_block">
          <h6 className="automobile_industry_heading">CHEMICAL</h6>
        </div>
        <div
          className={`automobile_industry_right_block ${
            showImage ? "show-image" : ""
          }`}
        >
          <div className="automobile_industry_image_block">
            <img
              src={Images?.industry3}
              alt="no-image"
              className="image_icon"
              style={{ objectFit: "contain" }}
            />
          </div>
        </div>
      </div>
      <div className="automobile_industry_head_design"></div>

      <div className="automobile_industry_content_section">
        <h6 className="automobile_industry_content_title">CHEMICAL</h6>
        <p className="automobile_industry_content_para">
          Marking and Coding on chemical products can be challenging due to
          harsh production environments that can be hot, dusty or wet. To
          achieve reliable, high <br />
          quality codes, your coding equipment should be engineered to withstand
          these challenges as well as near-constant production and frequent
          changeovers.
          <br /> From addressing internal quality control needs to meeting your
          customer’s traceability requirements, USP can help..
        </p>
      </div>

      <div className="automobile_industry_continuous_inkjet_printers">
        <div className="automobile_industry_continuous_inkjet_printers_left">
          <div className="inkjet_printers_left_block">
            <h6 className="inkjet_printers_title">
              Continuous InkJet Printers (ONLINE & OFFLINE)
            </h6>
            <div className="inkjet_printer_container">
              <div className="inkjet_image_card_block">
                {imageList?.map((data, i) => {
                  return (
                    <>
                      <div className="inkjet_card" key={i}>
                        <div className="inkjet_card_image">
                          <img
                            src={data?.path}
                            className="image_icon"
                            style={{ objectFit: "contain" }}
                          />
                        </div>
                        <h6 className="inkjet_card_title">{data?.imageName}</h6>
                        <Link to={data?.fileUrl} className="view_more">
                          View More
                        </Link>
                        <div className="download_image_block">
                          <a
                            href={data?.downloadFile}
                            download={data?.fileName}
                          >
                            <img
                              src={Images?.downloadIcon}
                              alt="no-image"
                              className="image_icon"
                            />
                          </a>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
            <h6 className="inkjet_printers_title">
              High Resolution Printers(OFFLINE)
            </h6>
            <div className="inkjet_printer_container">
              <div className="inkjet_image_card_block">
                {hightResolution?.map((data, i) => {
                  return (
                    <>
                      <div className="inkjet_card" key={i}>
                        <div className="inkjet_card_image">
                          <img
                            src={data?.path}
                            className="image_icon"
                            style={{ objectFit: "contain" }}
                          />
                        </div>
                        <h6 className="inkjet_card_title">{data?.imageName}</h6>
                        <Link to={data?.fileUrl} className="view_more">
                          View More
                        </Link>
                        <div className="download_image_block">
                          <a
                            href={data?.downloadFile}
                            download={data?.fileName}
                          >
                            <img
                              src={Images?.downloadIcon}
                              alt="no-image"
                              className="image_icon"
                            />
                          </a>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
            <h6 className="inkjet_printers_title">
              Laser Printers(ONLINE & OFFLINE)
            </h6>
            <div className="inkjet_printer_container">
              <div className="inkjet_image_card_block">
                {laserPrinter?.map((data, i) => {
                  return (
                    <>
                      <div className="inkjet_card" key={i}>
                        <div className="inkjet_card_image">
                          <img
                            src={data?.path}
                            className="image_icon"
                            style={{ objectFit: "contain" }}
                          />
                        </div>
                        <h6 className="inkjet_card_title">{data?.imageName}</h6>
                        <Link to={data?.fileUrl} className="view_more">
                          View More
                        </Link>
                        <div className="download_image_block">
                          <a
                            href={data?.downloadFile}
                            download={data?.fileName}
                          >
                            <img
                              src={Images?.downloadIcon}
                              alt="no-image"
                              className="image_icon"
                            />
                          </a>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <ContactUsSidebar />
      </div>
    </>
  );
};

export default ChemicalComp;
